import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-common-footer',
  templateUrl: './common-footer.component.html',
  styleUrls: ['./common-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonFooterComponent implements OnInit {

  constructor(
    private commonService: CommonService
  ) { }

  isSafariMobile: boolean = true
  public categories: any = []

  ngOnInit(): void {
    // Init Category
    this.commonService.categoryList.subscribe((response) => {
      //console.log("repsonse", response)
      this.categories = response
    })
    // this.isSafariMobile = /iPhone|iPad|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent);
  }

}
